import { render } from "./FrontLayout.vue?vue&type=template&id=3872d6a2&scoped=true"
import script from "./FrontLayout.vue?vue&type=script&lang=js"
export * from "./FrontLayout.vue?vue&type=script&lang=js"

import "./FrontLayout.vue?vue&type=style&index=0&id=3872d6a2&scoped=true&lang=less"
import "./FrontLayout.vue?vue&type=style&index=1&id=3872d6a2&lang=css"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3872d6a2"]])

export default __exports__